<template>
  <vs-table hover-flat v-if="taskCategories && taskCategories.length" :data="taskCategories" class="table-configuration-tasks-categories-list">
    <template slot="thead">
      <vs-th v-text="$t('no')"></vs-th>
      <vs-th v-text="$t('caller_company_name')"></vs-th>
      <vs-th v-text="$t('category_name')"></vs-th>
      <vs-th v-text="$t('description')"></vs-th>
      <vs-th class="text-center" v-text="$t('function')"></vs-th>
    </template>

    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td v-text="tr.count" :data-tr-title="$t('no')"></vs-td>
        <vs-td v-text="tr.company_name" :data-tr-title="$t('caller_company_name')"></vs-td>
        <vs-td :data-tr-title="$t('category_name')">
          <vs-input :placeholder="$t('category_name')" v-model="tr.name" class="w-full" v-if="tr.edit == true"/>
          <validation-error :model-error="tr.taskCategoryFormErrors.name"></validation-error>
          <span v-if="tr.edit == false">{{ tr.name }}</span>
        </vs-td>
        <vs-td :data-tr-title="$t('description')">
          <vs-input :placeholder="$t('description')" v-model="tr.description" class="w-full" v-if="tr.edit == true"/>
          <validation-error :model-error="tr.taskCategoryFormErrors.description"></validation-error>
          <span v-if="tr.edit == false">{{ tr.description }}</span>
        </vs-td>
        <vs-td>
          <div class="flex justify-center">
            <template v-if="tr.edit == true">
              <save-button @click="$emit('customClickSave', indextr, tr.id)" :id="'updateConfigurationTaskCategoryButton' + tr.id"></save-button>&nbsp;
              <cancel-button @click="$emit('customClickCancel', indextr, tr.id)"></cancel-button>
            </template>
            <template v-if="tr.edit == false">
              <edit-button @click="$emit('customClickEdit', indextr, tr.id)"></edit-button>&nbsp;
              <delete-button @click="$emit('customClickDelete', indextr, tr.id)"></delete-button>
            </template>
          </div>
        </vs-td>
      </vs-tr>
    </template>
  </vs-table>
  <vs-alert v-else class="flex justify-center p-0 h-auto" color="danger" active="true">
    <div v-text="$t('no_record')"></div>
  </vs-alert>
</template>

<script>
export default {
  name: 'Shared.Configuration.Task.Categories.List',
  props: {
    taskCategories: {
      type: [Object, Array],
      required: true
    }
  }
}
</script>

<style lang="scss">
  .table-configuration-tasks-categories-list {
    tr {
      th {
        &:nth-child(1) { width: 5%; }
        &:nth-child(2) { width: 25%; }
        &:nth-child(3) { width: 25%; }
        &:nth-child(4) { width: 30%; }
        &:nth-child(5) { width: 15%; }
      }

      th,
      td {
        vertical-align: middle;
      }
    }
  }
</style>
